import useHttp from './use-http';

// @ts-ignore
const usePayments = () => {
    const convertDate = (date) => {
        if (!date) {
            return null;
        }

        return new Date(date).toISOString();
    };

    const getPayments = (contactId, startDate = null, endDate = null, page = null) => {
        const url = `/api/v1/contacts/${contactId}/payments`;

        const { http } = useHttp();
        return http.get(url, {
            params: {
                page,
                start_date: convertDate(startDate),
                end_date: convertDate(endDate)
            }
        });
    };

    const getPaymentsTotal = (contactId, startDate = null, endDate = null) => {
        const url = `/api/v1/contacts/${contactId}/payments/total`;

        const { http } = useHttp();
        return http.get(url, {
            params: {
                start_date: convertDate(startDate),
                end_date: convertDate(endDate)
            }
        });
    };

    const exportPayments = (contactId, type, startDate, endDate) => {
        const url = `/api/v1/contacts/${contactId}/payments/export-payments/`;
        const { http } = useHttp();
        return http.post(url, {
            type,
            start_date: convertDate(startDate),
            end_date: convertDate(endDate)
        });
    };

    return {
        getPayments,
        getPaymentsTotal,
        exportPayments
    };
};

export default usePayments;
